import { render } from "./Swiper_1.vue?vue&type=template&id=055dcc18"
import script from "./Swiper_1.vue?vue&type=script&lang=js"
export * from "./Swiper_1.vue?vue&type=script&lang=js"

import "./Swiper_1.vue?vue&type=style&index=0&id=055dcc18&lang=scss"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__